export enum CustomQuestionStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}
